import React from 'react';
import { any, arrayOf, func, string } from 'prop-types';
import theme from 'resources/themes';
import CollapsibleContent from 'components/collapsible/CollapsibleContent';
import { useSidebar } from 'hooks/useSidebar';

function MenuItemComponent({ children, icon: Icon, id, items = [], level = 1, onClick, title }) {
  const isCollapsible = children && children.length > 0;
  const { isExpanded, isActive, onItemClick } = useSidebar({
    isCollapsible,
    item: id,
    items,
  });

  const iconColor = isActive ? theme.color.whiteColor : theme.color.whiteColor;

  function onItemClicked(e) {
    if (onClick) {
      onClick(e);
    }
    onItemClick();
  }

  return (
    <div
      key={id}
      style={{
        display: 'flex',
        flexDirection: 'column',
        ...(isActive && level <= 1
          ? { borderLeft: `3px solid ${theme.color.darkGrayishBlue}` }
          : {}),
      }}
    >
      <div
        onClick={onItemClicked}
        style={{
          display: 'flex',
          alignItems: 'center',
          height: 56,
          cursor: 'pointer',
          paddingLeft: 32 * level,
          transition: 'all 0.2s ease-in-out',
          ...(isActive ? { backgroundColor: theme.color.activeBg } : {}),
        }}
      >
        <Icon fill={iconColor} />
        <span
          style={{
            fontSize: 16,
            lineHeight: '20px',
            letterSpacing: '0.2px',
            color: theme.color.whiteColor,
            marginLeft: 24,
          }}
        >
          {title}
        </span>
      </div>
      {isCollapsible && (
        <CollapsibleContent expanded={isExpanded}>
          {children.map((child) => child.type({ ...child.props }))}
        </CollapsibleContent>
      )}
    </div>
  );
}

MenuItemComponent.propTypes = {
  children: any,
  icon: func,
  id: string,
  onClick: func,
  items: arrayOf(string),
  title: string,
};

export default MenuItemComponent;
